import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import Introduction from './sections/Introduction';
import Slogan from './sections/slogan';
import Social from './sections/Social';
import Game from './sections/Game';
import World from './sections/World';
import City from './sections/City';
import Characters from './sections/Characters';
import Drones from './sections/Drones';
import Mail from './sections/Mail';
import FinalCTA from './sections/FinalCTA';
import Steam from './sections/Steam';
import BreakImage from './sections/BreakImage';
import Footer from '../../components/footer/Footer'
import './Foxandshadow.css';

const Foxandshadow = () => {
  return (
    <>
      <Navbar />
      <div className="foxandshadow-container">
        <Introduction />
        <Slogan />
        <Social />
        <World />
        <BreakImage/>
        <Game />
        <City/>
        <Characters/>
        <Drones />
        <FinalCTA />
        <Steam />
        <Mail />
      </div>
      <Footer />
    </>
  );
};

export default Foxandshadow;